var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "py-0", attrs: { fluid: "" } },
    [
      _c(
        "v-form",
        {
          attrs: { name: "campaign_factory" },
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.send.apply(null, arguments)
            },
          },
        },
        [
          _c("v-select", {
            attrs: {
              dense: true,
              items: _vm.campaignFactoryForms,
              label: _vm.$t(
                "campaign_factory.form.label." + _vm.type + "_form_type"
              ),
              "item-text": "formType",
              required: "",
              disabled: undefined !== _vm.campaignFactory.id,
            },
            on: {
              change: function ($event) {
                return _vm.loadForm()
              },
            },
            model: {
              value: _vm.campaignFactory.className,
              callback: function ($$v) {
                _vm.$set(_vm.campaignFactory, "className", $$v)
              },
              expression: "campaignFactory.className",
            },
          }),
          _vm._v(" "),
          _vm.selectedCampaignFactoryForm
            ? _c(
                "div",
                _vm._l(
                  _vm.selectedCampaignFactoryForm.fields,
                  function (field, fieldKey) {
                    return _c(
                      "div",
                      { key: field.fieldKey },
                      [
                        "text" === field.type
                          ? _c("v-text-field", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: {
                                    required: _vm.hasConstraint(
                                      field,
                                      "NotBlank"
                                    ),
                                    factoryUrl: _vm.hasConstraint(
                                      field,
                                      "FactoryUrl"
                                    ),
                                  },
                                  expression:
                                    "{\n            required: hasConstraint(field, 'NotBlank'),\n            factoryUrl: hasConstraint(field, 'FactoryUrl')\n          }",
                                },
                              ],
                              attrs: {
                                dense: true,
                                name: fieldKey,
                                label: field.label,
                                hint: field.help,
                                "error-messages": _vm.errors.first(fieldKey),
                              },
                              model: {
                                value: _vm.campaignFactory.parameters[fieldKey],
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.campaignFactory.parameters,
                                    fieldKey,
                                    $$v
                                  )
                                },
                                expression:
                                  "campaignFactory.parameters[fieldKey]",
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isUrlField(field, fieldKey)
                          ? _c(
                              "v-row",
                              [
                                _c(
                                  "v-col",
                                  [
                                    _c("v-textarea", {
                                      directives: [
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: {
                                            required: _vm.hasConstraint(
                                              field,
                                              "NotBlank"
                                            ),
                                            factoryUrl: _vm.hasConstraint(
                                              field,
                                              "FactoryUrl"
                                            ),
                                          },
                                          expression:
                                            "{\n                required: hasConstraint(field, 'NotBlank'),\n                factoryUrl: hasConstraint(field, 'FactoryUrl')\n              }",
                                        },
                                      ],
                                      attrs: {
                                        rows: "1",
                                        dense: true,
                                        "auto-grow": true,
                                        name: fieldKey,
                                        label: field.label,
                                        hint: field.help,
                                        "error-messages":
                                          _vm.errors.first(fieldKey),
                                      },
                                      model: {
                                        value:
                                          _vm.campaignFactory.parameters[
                                            fieldKey
                                          ],
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.campaignFactory.parameters,
                                            fieldKey,
                                            $$v
                                          )
                                        },
                                        expression:
                                          "campaignFactory.parameters[fieldKey]",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-col",
                                  { attrs: { cols: "auto" } },
                                  [
                                    _c("campaign-factory-url-modal-component", {
                                      attrs: {
                                        url: _vm.campaignFactory.parameters[
                                          fieldKey
                                        ],
                                      },
                                      on: {
                                        "url-generated": function ($event) {
                                          return _vm.updateUrl(fieldKey, $event)
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        field.type == "integer"
                          ? _c("v-text-field", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: {
                                    required: _vm.hasConstraint(
                                      field,
                                      "NotBlank"
                                    ),
                                    numeric: _vm.hasConstraint(
                                      field,
                                      "Type",
                                      "Integer"
                                    ),
                                    min_value: _vm.hasConstraint(field, "Range")
                                      ? _vm.getRangeSide(field, "min")
                                      : false,
                                    max_value: _vm.hasConstraint(field, "Range")
                                      ? _vm.getRangeSide(field, "max")
                                      : false,
                                  },
                                  expression:
                                    "{\n            required: hasConstraint(field, 'NotBlank'),\n            numeric: hasConstraint(field, 'Type', 'Integer'),\n            min_value: hasConstraint(field, 'Range')\n              ? getRangeSide(field, 'min')\n              : false,\n            max_value: hasConstraint(field, 'Range')\n              ? getRangeSide(field, 'max')\n              : false\n          }",
                                },
                              ],
                              attrs: {
                                dense: true,
                                name: fieldKey,
                                label: field.label,
                                type: "number",
                                min: field.min,
                                max: field.max,
                                hint: field.help,
                                "error-messages": _vm.errors.first(fieldKey),
                              },
                              model: {
                                value: _vm.campaignFactory.parameters[fieldKey],
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.campaignFactory.parameters,
                                    fieldKey,
                                    _vm._n($$v)
                                  )
                                },
                                expression:
                                  "campaignFactory.parameters[fieldKey]",
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        field.type == "checkbox"
                          ? _c("v-switch", {
                              attrs: {
                                dense: true,
                                name: fieldKey,
                                label: field.label,
                                hint: field.help,
                                "persistent-hint": true,
                              },
                              model: {
                                value: _vm.campaignFactory.parameters[fieldKey],
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.campaignFactory.parameters,
                                    fieldKey,
                                    $$v
                                  )
                                },
                                expression:
                                  "campaignFactory.parameters[fieldKey]",
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        field.type == "choice"
                          ? _c("v-select", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: {
                                    required: _vm.hasConstraint(
                                      field,
                                      "NotBlank"
                                    ),
                                  },
                                  expression:
                                    "{\n            required: hasConstraint(field, 'NotBlank')\n          }",
                                },
                              ],
                              attrs: {
                                dense: true,
                                name: fieldKey,
                                label: field.label,
                                hint: field.help,
                                items: _vm.formatChoices(
                                  field.choices,
                                  fieldKey
                                ),
                                multiple: field.multiple,
                                "error-messages": _vm.errors.first(fieldKey),
                              },
                              model: {
                                value: _vm.campaignFactory.parameters[fieldKey],
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.campaignFactory.parameters,
                                    fieldKey,
                                    $$v
                                  )
                                },
                                expression:
                                  "campaignFactory.parameters[fieldKey]",
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        field.type === "textarea"
                          ? _c("v-textarea", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: {
                                    required: _vm.hasConstraint(
                                      field,
                                      "NotBlank"
                                    ),
                                    factoryUrl: _vm.hasConstraint(
                                      field,
                                      "FactoryUrl"
                                    ),
                                  },
                                  expression:
                                    "{\n            required: hasConstraint(field, 'NotBlank'),\n            factoryUrl: hasConstraint(field, 'FactoryUrl')\n          }",
                                },
                              ],
                              attrs: {
                                dense: true,
                                name: fieldKey,
                                label: field.label,
                                hint: field.help,
                                "error-messages": _vm.errors.first(fieldKey),
                              },
                              model: {
                                value: _vm.campaignFactory.parameters[fieldKey],
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.campaignFactory.parameters,
                                    fieldKey,
                                    $$v
                                  )
                                },
                                expression:
                                  "campaignFactory.parameters[fieldKey]",
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        field.type === "richtexteditor" &&
                        !_vm.isUrlField(field, fieldKey)
                          ? _c("json-editor-component", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: {
                                    required: _vm.hasConstraint(
                                      field,
                                      "NotBlank"
                                    ),
                                  },
                                  expression:
                                    "{ required: hasConstraint(field, 'NotBlank') }",
                                },
                              ],
                              attrs: {
                                placeholders:
                                  _vm.placeholdersForField(fieldKey),
                                name: fieldKey,
                                label: field.label,
                                hint: field.help,
                                "error-messages": _vm.errors.first(fieldKey),
                                required: _vm.hasConstraint(field, "NotBlank"),
                                "validate-json": _vm.isJsonField(fieldKey),
                                "csv-template":
                                  _vm.isCsvTemplateField(fieldKey),
                                "enable-format-toggle": fieldKey === "body",
                                "show-header-suggestions":
                                  fieldKey === "headers",
                                "show-consent-function":
                                  _vm.showConsentFunction(fieldKey),
                              },
                              model: {
                                value: _vm.campaignFactory.parameters[fieldKey],
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.campaignFactory.parameters,
                                    fieldKey,
                                    $$v
                                  )
                                },
                                expression:
                                  "campaignFactory.parameters[fieldKey]",
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        field.type == "collection"
                          ? _c(
                              "v-sheet",
                              {
                                class: _vm.getClassFromAttr(field),
                                attrs: { color: "grey lighten-4" },
                              },
                              [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(field.label) +
                                    "\n          "
                                ),
                                _vm._l(
                                  _vm.campaignFactory.parameters[fieldKey],
                                  function (embedFormModel, embedModelIndex) {
                                    return _c(
                                      "v-row",
                                      {
                                        key: "row" + embedModelIndex,
                                        attrs: { dense: true },
                                      },
                                      [
                                        _vm._l(
                                          field.fields,
                                          function (embedField, embedFieldKey) {
                                            return _c(
                                              "v-col",
                                              {
                                                key:
                                                  embedFieldKey +
                                                  "-" +
                                                  embedModelIndex,
                                              },
                                              [
                                                embedField.type == "text"
                                                  ? _c("v-text-field", {
                                                      directives: [
                                                        {
                                                          name: "validate",
                                                          rawName: "v-validate",
                                                          value: {
                                                            required:
                                                              embedModelIndex ==
                                                              0
                                                                ? _vm.hasConstraint(
                                                                    embedField,
                                                                    "NotBlank"
                                                                  )
                                                                : false,
                                                          },
                                                          expression:
                                                            "{\n                  required:\n                    embedModelIndex == 0\n                      ? hasConstraint(embedField, 'NotBlank')\n                      : false\n                }",
                                                        },
                                                      ],
                                                      attrs: {
                                                        dense: true,
                                                        name:
                                                          embedFieldKey +
                                                          "-" +
                                                          embedModelIndex,
                                                        label: embedField.label,
                                                        hint: embedField.help,
                                                        "error-messages":
                                                          _vm.errors.first(
                                                            embedFieldKey +
                                                              "-" +
                                                              embedModelIndex
                                                          ),
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.campaignFactory
                                                            .parameters[
                                                            fieldKey
                                                          ][embedModelIndex][
                                                            embedFieldKey
                                                          ],
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.campaignFactory
                                                              .parameters[
                                                              fieldKey
                                                            ][embedModelIndex],
                                                            embedFieldKey,
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "\n                  campaignFactory.parameters[fieldKey][embedModelIndex][\n                    embedFieldKey\n                  ]\n                ",
                                                      },
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                embedField.type == "checkbox"
                                                  ? _c("v-switch", {
                                                      attrs: {
                                                        dense: true,
                                                        name:
                                                          embedFieldKey +
                                                          "-" +
                                                          embedModelIndex,
                                                        label: embedField.label,
                                                        hint: embedField.help,
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.campaignFactory
                                                            .parameters[
                                                            fieldKey
                                                          ][embedModelIndex][
                                                            embedFieldKey
                                                          ],
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.campaignFactory
                                                              .parameters[
                                                              fieldKey
                                                            ][embedModelIndex],
                                                            embedFieldKey,
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "\n                  campaignFactory.parameters[fieldKey][embedModelIndex][\n                    embedFieldKey\n                  ]\n                ",
                                                      },
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                embedField.type == "choice"
                                                  ? _c("v-select", {
                                                      directives: [
                                                        {
                                                          name: "validate",
                                                          rawName: "v-validate",
                                                          value: {
                                                            required:
                                                              embedModelIndex ==
                                                              0
                                                                ? _vm.hasConstraint(
                                                                    embedField,
                                                                    "NotBlank"
                                                                  )
                                                                : false,
                                                          },
                                                          expression:
                                                            "{\n                  required:\n                    embedModelIndex == 0\n                      ? hasConstraint(embedField, 'NotBlank')\n                      : false\n                }",
                                                        },
                                                      ],
                                                      attrs: {
                                                        dense: true,
                                                        name:
                                                          embedFieldKey +
                                                          "-" +
                                                          embedModelIndex,
                                                        label: embedField.label,
                                                        hint: embedField.help,
                                                        items:
                                                          _vm.formatChoices(
                                                            embedField.choices,
                                                            embedFieldKey
                                                          ),
                                                        multiple:
                                                          embedField.multiple,
                                                        "error-messages":
                                                          _vm.errors.first(
                                                            embedFieldKey +
                                                              "-" +
                                                              embedModelIndex
                                                          ),
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.campaignFactory
                                                            .parameters[
                                                            fieldKey
                                                          ][embedModelIndex][
                                                            embedFieldKey
                                                          ],
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.campaignFactory
                                                              .parameters[
                                                              fieldKey
                                                            ][embedModelIndex],
                                                            embedFieldKey,
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "\n                  campaignFactory.parameters[fieldKey][embedModelIndex][\n                    embedFieldKey\n                  ]\n                ",
                                                      },
                                                    })
                                                  : _vm._e(),
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-col",
                                          { attrs: { cols: "auto" } },
                                          [
                                            _c(
                                              "v-btn",
                                              {
                                                attrs: {
                                                  fab: true,
                                                  small: true,
                                                  color: "red",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.removeRow(
                                                      fieldKey,
                                                      embedModelIndex
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  { attrs: { color: "white" } },
                                                  [_vm._v("mdi-minus")]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      2
                                    )
                                  }
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-row",
                                  { attrs: { dense: true } },
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          block: true,
                                          color: "grey darken-3",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.addRow(fieldKey)
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "v-icon",
                                          { attrs: { color: "white" } },
                                          [_vm._v("mdi-plus")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              2
                            )
                          : _vm._e(),
                      ],
                      1
                    )
                  }
                ),
                0
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }